import { StatusBadge } from "@/components/StatusBadge";
import { formatDate } from "@/lib/helpers";
import { MapPin } from "lucide-react";

// Student Detail -> "Student Information" card. Extracted from
// StudentDetail.js (props-driven, no behavior change).
export const StudentInfoCard = ({ student }) => (
  <section className="rounded-[var(--radius)] border bg-card p-4 sm:p-5 space-y-3" data-testid="student-info-card">
    <h2 className="font-semibold font-heading">Student Information</h2>
    <div className="grid sm:grid-cols-2 gap-3 text-sm">
      <div><span className="text-muted-foreground">Phone: </span>{student.phone || "-"}</div>
      <div><span className="text-muted-foreground">Date of birth: </span>{student.dob ? formatDate(student.dob) : "-"}</div>
      <div><span className="text-muted-foreground">Emergency contact: </span>{student.emergency_contact_name || "-"} {student.emergency_contact_phone && `(${student.emergency_contact_phone})`}</div>
      <div><span className="text-muted-foreground">Permit #: </span>{student.permit_number || "-"}</div>
      <div className="sm:col-span-2 flex items-center gap-1">
        <MapPin className="h-3.5 w-3.5 text-muted-foreground" />
        <span className="text-muted-foreground">Default meeting location: </span>{student.default_meeting_location || "Not set"}
      </div>
      <div className="sm:col-span-2 flex items-center gap-1">
        <MapPin className="h-3.5 w-3.5 text-muted-foreground" />
        <span className="text-muted-foreground">Navigation address: </span>{student.navigation_address || "-"}
      </div>
      <div><span className="text-muted-foreground">Assigned instructor: </span>{student.assigned_instructor_name || "Unassigned"}</div>
      <div><span className="text-muted-foreground">Total mileage: </span>{student.mileage_total || 0} mi</div>
      <div><span className="text-muted-foreground">Classroom hours completed: </span>{student.classroom_hours_completed || 0}</div>
      <div><span className="text-muted-foreground">Observation hours completed: </span>{student.observation_hours_completed || 0}</div>
      <div><span className="text-muted-foreground">Status: </span><StatusBadge status={student.status} /></div>
    </div>
  </section>
);
